import useAIChatBotStore from '@store/useAIChatBotStore';
import loader from '../../../public/assets/gen-ai-splash.json';
import Lottie from 'lottie-react';
import { Text } from '@ui/atoms';
import Button from '@ui/atoms/design-system/Button';
import texts from "./en.json";

const AskMeBanner = ({ wrapperClassName = '' }) => {
    const { toggleVisibility } = useAIChatBotStore((state) => ({
        toggleVisibility: state.toggleVisibility,
    }));
    return (
        <div className={`text-center relative bg-gen-ai-opportunity-details-banner-mobile lg:bg-gen-ai-opportunity-details-banner justify-between items-center rounded-xl p-4 z-20 ${wrapperClassName}`}>
            <div className='flex gap-3 items-center'>
                <div className='min-w-11'>
                    <Lottie
                        animationData={loader}
                        loop={false}
                        className={`w-11 h-11`}
                    />
                </div>
                <div className='flex flex-col gap-1'>
                    <Text
                        content={`${texts?.AskMeBannerTitle}. <span class='xl:hidden p4-regular'>${texts?.AskMeBannerDescription}</span>`}
                        className="p4-semibold text-purple-500 text-left"
                        isInnerHtml
                    />
                    <Text
                        content={texts?.AskMeBannerDescription}
                        className='p5-regular text-purple-500 text-left xl:block hidden'
                    />
                </div>
            </div>

            <Button
               buttonText={texts?.AskJiraafAI}
               buttonType='tertiary'
               buttonSize='small'
               widthClass={'w-full md:w-auto'}
               className='mt-4 md:mt-0'
               onClick={toggleVisibility}
            />
        </div>
    );
};

export default AskMeBanner;
